import { createContext, useContext } from 'react';

export interface PushNotificationsContextType {
  isSubscribed: boolean;
  isLoading: boolean;
  status: StatusMessage | null;
  subscribe: () => Promise<void>;
  unsubscribe: () => Promise<void>;
  clearStatus: () => void;
  arePushNotificationsAllowed: boolean | undefined;
  setArePushNotificationsAllowed: (unixDate: boolean) => void;
}

export interface StatusMessage {
  title: string;
  description: string;
  type: 'success' | 'error';
  permission?: boolean;
  subscription?: boolean;
}

export const PushNotificationsContext = createContext<
  PushNotificationsContextType | undefined
>(undefined);

export const usePushNotificationsContext = (): PushNotificationsContextType => {
  const context = useContext(PushNotificationsContext);
  if (context === undefined) {
    throw new Error('usePushNotificationsContext must be used within a NotificationsProvider');
  }
  return context;
};
